<template>
  <Modal
    :title="modalTitle"
    :saving="saving"
    class-name="small-modal"
    @hide-modal="$emit('hide-modal')"
    @submit="handleSave"
  >
    <TextField
      v-model="formData.summary"
      name="summary"
      label="To-Do"
      placeholder="Enter To-Do"
      :validation-errors="v$.$errors"
      class="block mb-2 full-width"
    />
    <div class="d-flex mb-2">
      <SelectBox
        v-model="formData.owner_id"
        name="owner_id"
        label="Assigned To"
        :options="adminsOptions"
        placeholder="Assigned To"
        :validation-errors="v$.$errors"
        class="flex-1 mr-3"
      />
      <Datepicker
        v-model="formData.due_by"
        name="Due By"
        label="Due By"
        hint-label="(Optional)"
        placeholder="MM/DD/YY"
        class="flex-1"
        :disabled-date="isAfterToday"
      />
    </div>
    <div class="text-gray font-italic">
      <div v-if="toDo.todo_item_id">{{ createdAtText }}</div>
      <div v-if="toDo.updated_at">{{ updatedAtText }}</div>
    </div>
  </Modal>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";

import Datepicker from "@/components/Datepicker.vue";
import Modal from "@/components/Modal.vue";
import SelectBox from "@/components/SelectBox.vue";
import TextField from "@/components/TextField.vue";
import CONSTANTS from "@/Constants.js";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  components: {
    Modal,
    SelectBox,
    TextField,
    Datepicker
  },
  props: {
    toDo: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["hide-modal", "refresh-todos"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  validations() {
    return {
      formData: {
        summary: { required, $autoDirty: true },
        owner_id: { required, $autoDirty: true }
      }
    };
  },
  data() {
    return {
      formData: {},
      saving: false
    };
  },
  computed: {
    ...mapState(["admins"]),
    ...mapState({
      adminsOptions: ({ admins }) =>
        admins.map((admin) => ({
          value: admin.admin_id,
          label: admin.full_name
        }))
    }),
    modalTitle() {
      const action = this.toDo.todo_item_id ? "Edit" : "New";
      return `${action} To-Do`;
    },
    createdAtText() {
      const author = this.formData.author.full_name;
      const date = moment(this.toDo.created_at).format(
        CONSTANTS.DATE_TIME_FORMAT_YEAR_LONG
      );
      return `Created by: ${author} on ${date}`;
    },
    updatedAtText() {
      const date = moment(this.toDo.updated_at).format(
        CONSTANTS.DATE_TIME_FORMAT_YEAR_LONG
      );
      return `Last updated at: ${date}`;
    }
  },
  watch: {
    toDo(newValue) {
      if (newValue.todo_item_id) {
        this.formData = {
          ...this.toDo,
          owner_id: newValue.owner.admin_id
        };
      }
    }
  },
  mounted() {
    if (!this.admins.length) {
      this.fetchAdmins();
    }
  },
  methods: {
    ...mapActions(["createTodo", "fetchAdmins", "updateTodo"]),
    isAfterToday(date) {
      return moment().isAfter(date, "days");
    },
    handleSave() {
      this.v$.$validate().then((valid) => {
        if (valid) {
          this.saving = true;
          const saveFunction = this.toDo.todo_item_id
            ? this.updateTodo
            : this.createTodo;
          const action = this.toDo.todo_item_id ? "updated" : "created";
          saveFunction({
            ...this.formData
          })
            .then(() => {
              window.notify.success(`To-Do successfully ${action}`);
              this.$emit("hide-modal");
              this.$emit("refresh-todos");
            })
            .finally(() => (this.saving = false));
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
